@if (isPortalMode) {
  <m-modal
    [visible]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="false"
    [closable]="false"
    [closeOnEscape]="false"
    (onHide)="onVersionUpdateModalClose()"
    [style]="{ width: '500px' }"
    class="custom-dialog">
    <ng-container modalHeader>
      <span class="h4 mb-0"> Page Refresh Required </span>
    </ng-container>
    <div class="flex flex-col gap-4 p-8">
      <p class="b1 text-gray-1000 mb-0">
        A refresh is needed to receive the most recent updates to your Measured
        account.
      </p>
      <p class="b1 text-gray-1000 mb-0">
        You will be returned to your Measured account after this action is
        completed.
      </p>
    </div>
    <ng-container modalFooter>
      <div class="flex justify-end gap-3">
        <m-button type="primary" (click)="onVersionUpdateAccept()">
          <span>Proceed</span>
        </m-button>
      </div>
    </ng-container>
  </m-modal>
}

@if (!isPortalMode) {
  <p-dialog
    [visible]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="false"
    [closable]="false"
    [closeOnEscape]="false"
    (onHide)="onVersionUpdateModalClose()"
    [style]="{ width: '500px' }"
    styleClass="saas-ui version-update-modal">
    <ng-template pTemplate="header">
      <span class="sh2 text-gray-1000"> Page Refresh Required </span>
    </ng-template>
    <div class="d-flex flex-column gap-4">
      <span class="b1 text-gray-1000">
        A refresh is needed to receive the most recent updates to your Measured
        account.
      </span>
      <span class="b1 text-gray-1000">
        You will be returned to your Measured account after this action is
        completed.
      </span>
    </div>
    <ng-template pTemplate="footer">
      <div class="flex justify-end">
        <p-button
          [label]="'Proceed'"
          (onClick)="onVersionUpdateAccept()"
          styleClass="p-button-primary">
        </p-button>
      </div>
    </ng-template>
  </p-dialog>
}
